<template>
  <div class="inside">
    <!-- <div class="back" @click="back()"></div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    
  },
};
</script>

<style scoped>
.inside {
 
  position: absolute;

}

.back {
  width: 1.8vw;
  height: 3.6vh;
  position: absolute;
  background: url("../assets/img/back.png") no-repeat;
  right: 2.1vw;
  top: 8vh;
  cursor: pointer;
  z-index: 10;
}
</style>
